import { getAlphaExtendedThinkingMode } from './getAlphaExtendedThinkingMode';
import type { ChatMode, ReasoningMode } from './types';

export const getDerivedReasoningMode = (
	reasoningMode: ReasoningMode,
): Pick<
	ChatMode,
	| 'deepResearchEnabled'
	| 'thinkDeeperEnabled'
	| 'fastModeEnabled'
	| 'autoReasoningEnabled'
	| 'alphaExtendedThinkingMode'
	| 'taskModeEnabled'
> => {
	const isThinkDeeperMode =
		reasoningMode === 'think-deeper' ||
		reasoningMode === 'think-deeper-marathon' ||
		reasoningMode === 'think-deeper-orchestrator';

	return {
		deepResearchEnabled: reasoningMode === 'deep-research',
		thinkDeeperEnabled: isThinkDeeperMode,
		fastModeEnabled: reasoningMode === 'fast',
		autoReasoningEnabled: reasoningMode === 'auto',
		alphaExtendedThinkingMode: getAlphaExtendedThinkingMode(reasoningMode),
		taskModeEnabled: reasoningMode === 'task',
	};
};
